<template>
  <div class="ciphertext">
    <div class="centerStructure">
      <div class="collectCustomerParameters">
        <div class="formbox">
          <el-form :rules="rules" :model="formData" label-width="100px" ref="ruleForm1">
            <div id="one" class="one"><i></i><span>配置参数加解密</span></div>
            <el-form-item label="操作：" class="inputLabel" prop="typeC">
              <template>
                <el-radio style="height: 33px" v-model="formData.typeC" border label='1'>加密</el-radio>
                <el-radio style="height: 33px" v-model="formData.typeC" border label='2'>解密</el-radio>
              </template>
            </el-form-item>
            <el-form-item label="原数据：" class="inputLabel" prop="codeC">
              <el-input class="wh200"
                        type="textarea"
                        :rows="1"
                        placeholder="请输入内容"
                        :autosize="true"
                        :clearable="true"
                        v-model.trim="formData.codeC">
              </el-input>
              <el-button style="height: 33px; margin-left: 20px;" type="primary" @click="doMainC()"
                         icon="el-icon-receiving">执行
              </el-button>
            </el-form-item>
            <el-form-item label="执行结果：" class="inputLabel" prop="resC">
              <el-input class="wh200"
                        type="textarea"
                        :rows="1"
                        :autosize="true"
                        :readonly="true"
                        v-model="formData.resC">
              </el-input>
            </el-form-item>
          </el-form>
            <el-form :rules="rules" :model="formData" label-width="100px" ref="ruleForm2">
            <div id="two" class="two"><i></i><span>敏感信息加解密</span></div>
            <el-form-item label="操作：" class="inputLabel" prop="typeS">
              <template>
                <el-radio style="height: 33px" v-model="formData.typeS" border label='1'>加密</el-radio>
                <el-radio style="height: 33px" v-model="formData.typeS" border label='2'>解密</el-radio>
              </template>
            </el-form-item>
            <el-form-item label="原数据：" class="inputLabel" prop="codeS">
              <el-input class="wh200"
                        type="textarea"
                        :rows="1"
                        placeholder="请输入内容"
                        :autosize="true"
                        :clearable="true"
                        v-model.trim="formData.codeS">
              </el-input>
              <el-button style="height: 33px; margin-left: 20px;" type="primary" @click="doMainS()"
                         icon="el-icon-receiving">执行
              </el-button>
            </el-form-item>
            <el-form-item label="执行结果：" class="inputLabel" prop="resS">
              <el-input class="wh200"
                        type="textarea"
                        :rows="1"
                        :autosize="true"
                        :readonly="true"
                        v-model="formData.resS">
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Mixins} from '@/config/mixins/mixins'
import {$http} from "@/config/api/axios";
// import {IsInteger} from "@/config/validate/common";
// import {IsNumber} from "../../../../../config/validate/common";


export default {
  name: "ciphertext",
  mixins: [Mixins],
  components: {},
  data() {
    return {
      formData: {
        codeC: '',
        codeS: '',
        resC: '',
        resS: '',
        typeC: '1',
        typeS: '1'
      },
      rules:{
        codeC:[
          {required:true,message:'原数据不能为空',trigger:['blur']},
        ],
        codeS:[
          {required:true,message:'原数据不能为空',trigger:['blur']},
        ]
      },
    }
  },
  methods: {
    doMainS() {
      this.core(this.formData.typeS=='1'?3:4,this.formData.codeS)
    },
    doMainC() {
      this.core(this.formData.typeC=='1'?1:2,this.formData.codeC)
    },
    core(witchOne,param) {
      let ruleForm = this.$refs.ruleForm1;
          let params = {
            code: param
          };
          let url;
          switch (witchOne) {
            case 1:
              ruleForm=this.$refs.ruleForm1;
              url="basic/admin/pass/config/encode";
              break;
            case 2:
              ruleForm=this.$refs.ruleForm1;
              url="basic/admin/pass/config/decode";
              break;
            case 3:
              ruleForm=this.$refs.ruleForm2;
              url="basic/admin/pass/sensitive/encode";
              break;
            case 4:
              ruleForm=this.$refs.ruleForm2;
              url="basic/admin/pass/sensitive/decode";
              break;
            default:
              break;
          }
      ruleForm.validate((valid) => {
        if (valid) {
          $http('get', url, params).then(res => {
            if (!!res.message) {
              this.msgerror(res.message)
            } else {
              switch (witchOne) {
                case 1:
                case 2:
                  this.formData.resC = res.data
                  break;
                case 3:
                case 4:
                  this.formData.resS = res.data
                default:
                  break;
              }
            }
          })
        } else {
          setTimeout(() => {
            var isError = document.getElementsByClassName("is-error");
            isError[0].querySelector('input').focus();
          }, 100);
          return false;
        }})
      }
  },
  mounted() {
    // this.getData();
  }
}
</script>

<style lang="less">
.ciphertext {
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
  display: flex;
  position: relative;

  .el-tabs {
    height: 100%;
    margin-top: -15px;

    .el-tab-pane {
      height: 100%;
    }

    .el-tabs__content {
      height: calc(100% - 50px) !important;

      .meterReading {
        height: 100%;
      }
    }
  }

  .collectCustomerParameters {
    .formbox {
      max-height: 776px;

      .remark {
        float: left;
        margin-left: 20px;
      }

      .el-input-group__append, .el-input-group__prepend {
        padding: 5px;
        color: #909399;
      }

      .el-input {
        float: left;
      }

      .inputLabel {
        width: 100%;

        .el-form-item__label {
          width: 180px !important;
        }
      }

      .leftSpan {
        margin-left: 21px;
      }

      .timeWidth {
        width: 100px;
      }

    }

    .myButton {
      margin-left: 18%;
    }

    .myButtonCalculation {
      margin-left: 20px;
      float: left;
    }

    .el-form-item__error {
      left: 80px;
    }

  }
}

.time222 {
  width: 100px;
}
</style>